module.exports = __webpack_public_path__ + "img/h_s2e1_gallery_2.92f455a6.png";